<template>

    <div class="settings">

        <header-band
            v-if="$mq === 'lg'"
            :back="!isPageSettings || fetching"
            :title="computedTitle"
            @eventBack="back"
        ></header-band>

        <div class="error-message" v-show="isShutdown">
            <img src="/img/icons/alert-white.svg">
            <span class="text-baseRegular color__white">{{ shutdownMessage }}</span>
        </div>

        <div class="error-message" v-show="isInvalidGrant">
            <img src="/img/icons/alert-white.svg">
            <span class="text-baseRegular color__white">{{ invalidGrantMessage }}</span>
            <button class="text-baseMedium ml__8" @click="reconnectInvalidGrant">{{ $t('reconnect') }}</button>
        </div>

        <div v-if="!error" class="desktop-container noselect">

            <template v-if="isDesktop">

            </template>

            <template v-else>

                <div class="settings__spacer"></div>

                <div class="settings__title-container">

                    <img v-if="showBackBtn" class="settings__back-img" src="/img/icons/arrow-right-blue.svg"
                         @click="back">

                    <h1 class="settings__title">{{ computedTitle }}</h1>

                </div>

                <div class="settings__spacer"></div>

            </template>

            <!--SETTINGS-->

            <div v-if="isPageSettings">

                <div v-for="(account, index) in mailboxes"
                     :class="{
                      'settings__bloc': true,
                      'settings__bloc-top': index === 0,
                      'settings__bloc-bottom': index === ((user.accounts) ? (user.accounts.length - 1) : 0)
                     }"
                     @click="goDetails(account.email)"
                >
                    <div class="settings__bloc-left">
                        <div class="settings__bloc-item settings__bloc-item-left">
                            <img src="/img/icons/alert-red.svg" class="alert"
                                 v-if="account.providerShutdown || account.invalidGrant">
                            <img src="/img/icons/newsletter-fill.svg" class="img__lang" v-else>
                        </div>
                        <p class="settings__bloc-text">{{ account.email }}</p>
                    </div>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-arrow" src="/img/icons/arrow-grey.svg">
                    </div>
                </div>
                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>
                <div class="settings__bloc settings__bloc-bottom" @click="addInbox">
                    <p class="text-lSemibold color__aquamarine">{{ $t('statistics_add_mailbox') }}</p>
                    <img src="/img/settings/add.svg" class="img__24">
                </div>

                <div class="settings__spacer"></div>

                <div class="settings__bloc settings__bloc-top settings__bloc-bottom" @click="goNotifications">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/bell-fill.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('settings_notifications') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-arrow" src="/img/icons/arrow-grey.svg">
                    </div>
                </div>


                <div class="settings__spacer"></div>


                <div class="settings__bloc settings__bloc-top" @click="rateCleanfox">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/heart-fill.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('settings_rate') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-item__arrow" src="/img/icons/arrow-square-up-right-fill.svg">
                    </div>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>

                <div class="settings__bloc" @click="contactUs">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/message-fill.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('settings_contact') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-item__arrow" src="/img/icons/arrow-square-up-right-fill.svg">
                    </div>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>

                <div class="settings__bloc settings__bloc-bottom" @click="goFaq">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/ask-fill.svg">
                    </div>
                    <p class="settings__bloc-text">{{ $t('settings_faq') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-item__arrow" src="/img/icons/arrow-square-up-right-fill.svg">
                    </div>
                </div>


                <div class="settings__spacer"></div>


                <div class="settings__bloc settings__bloc-top" @click="goTerms">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/doc-fill.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('terms_of_service') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-item__arrow" src="/img/icons/arrow-square-up-right-fill.svg">
                    </div>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>


                <div class="settings__bloc" @click="goPrivacy">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/privacy-fill.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('privacy_notice') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-item__arrow" src="/img/icons/arrow-square-up-right-fill.svg">
                    </div>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>

                <div class="settings__bloc" @click="goYourPrivacy">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/info-white.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">
                        <span>{{ $t('your_privacy_right') }}</span>
                        <img class="ml__8" src="/img/icons/privacy.svg">
                    </p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-item__arrow" src="/img/icons/arrow-square-up-right-fill.svg">
                    </div>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>

                <div class="settings__bloc" @click="goHDPN">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/hdpn.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">
                        <span>{{ $t('health_data_privacy_policy') }}</span>
                    </p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-item__arrow" src="/img/icons/arrow-square-up-right-fill.svg">
                    </div>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>

                <div class="settings__bloc" @click="goVDP">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/vdp.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">
                        <span>{{ $t('new_footer_vulnerability_disclosure_program') }}</span>
                    </p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-item__arrow" src="/img/icons/arrow-square-up-right-fill.svg">
                    </div>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>

                <div class="settings__bloc" @click="goMyData">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/lock-blue.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('new_footer_data_use') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-arrow" src="/img/icons/arrow-grey.svg">
                    </div>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>

                <div :class="{ 'settings__bloc-bottom': !isGerman }" class="settings__bloc" @click="goCookies">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/cookie-fill-blue.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('your_cookie_choices') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-arrow" src="/img/icons/arrow-grey.svg">
                    </div>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>

                <div class="settings__bloc settings__bloc-bottom" @click="goImpressum">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/privacy-fill.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('legal_notices') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-arrow" src="/img/icons/arrow-grey.svg">
                    </div>
                </div>


                <div class="settings__spacer"></div>


                <div class="btn btn-red btn-big settings__btn-red" @click="btnDisconnect">

                    <p class="settings__bloc-text settings__bloc-text-white">{{ $t('settings_disconnect') }}</p>

                </div>


                <div class="settings__spacer"></div>


                <h1 class="settings-title">{{ $t('settings_title_privacy') | toUpperCase }}</h1>

                <p class="privacy-text">{{ $t('settings_text_privacy') }}</p>

                <div class="settings-grey-logo-container">

                    <img class="" src="/img/settings/cleanfox-logo.svg">

                </div>

                <p class="app-version">{{ getVersion() }}</p>

            </div>

            <!--DETAILS-->

            <div v-show="isPageDetails">

                <div class="settings__bloc settings__bloc-topg settings__bloc-bottom" @click="goPanel">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/panel-fill.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('settings_mailbox_panel') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-arrow" src="/img/icons/arrow-grey.svg">
                    </div>
                </div>

                <div class="settings__spacer"></div>

                <div class="btn btn-red btn-big" @click="openModalDelete">
                    <p class="settings__bloc-text settings__bloc-text-left settings__bloc-text settings__bloc-text-white">
                        {{ $t('settings_mailbox_delete') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-img-close" src="/img/icons/close-fill.svg">
                    </div>
                </div>

            </div>

            <!--PANEL-->

            <div v-show="isPagePanel">

                <div class="settings__bloc settings__bloc-top settings__bloc-bottom"
                     :class="{'settings__bloc__shutdown': isShutdown}">
                    <p class="settings__bloc-text settings__bloc-text-left">{{ $t('settings_panel_exclude') }}</p>

                    <checkbox-circle-v2 :value="isExcludeFromPanel" @click="panelUpdate"></checkbox-circle-v2>

                </div>

                <markdown :text="$t('settings_text_privacy_updated')" class="text text-panel"></markdown>

            </div>

            <!--NOTIFICATIONS-->

            <div v-if="isPageNotifications">

                <div class="settings__bloc settings__bloc-top settings__bloc-bottom">
                    <p class="settings__bloc-text settings__bloc-text-left">
                        {{ $t('settings_notifications_global_switch') }}</p>
                    <checkbox-circle
                        v-if="isPageNotifications"
                        :disabled="isNotGranted"
                        :state="isRegistered"
                        @change="notificationsUpdateAll"
                        @click="clickSwitchNotifs('all')"
                    ></checkbox-circle>
                </div>

                <div class="settings__spacer"></div>

                <p class="settings__subtitle">{{ $t('settings_notifications_notifications_sent') | toUpperCase }}</p>

                <div class="settings__bloc settings__bloc-top">
                    <p class="settings__bloc-text settings__bloc-text-left">
                        {{ $t('settings_notifications_switch_title_1') }}</p>
                    <checkbox-circle
                        v-if="isPageNotifications"
                        :disabled="isNotGranted"
                        :state="notificationsStateNews"
                        @change="specificNotificationsUpdate($event, 'news')"
                        @click="clickSwitchNotifs('news')"
                    ></checkbox-circle>
                </div>
                <div class="settings__bloc settings__bloc-secondary">

                    <p class="settings__bloc-secondary-text">{{ $t('settings_notifications_switch_description_1') }}</p>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>

                <div class="settings__bloc">
                    <p class="settings__bloc-text settings__bloc-text-left">
                        {{ $t('settings_notifications_switch_title_2') }}</p>
                    <checkbox-circle
                        v-if="isPageNotifications"
                        :disabled="isNotGranted"
                        :state="notificationsStateImportant"
                        @change="specificNotificationsUpdate($event, 'important')"
                        @click="clickSwitchNotifs('important')"
                    ></checkbox-circle>
                </div>
                <div class="settings__bloc settings__bloc-secondary settings__bloc-bottom">

                    <p class="settings__bloc-secondary-text">{{ $t('settings_notifications_switch_description_2') }}</p>
                </div>

            </div>

            <!--COOKIES_POLICY-->

            <div v-if="isPageCookiesNotifications">

                <div class="settings__bloc settings__bloc-top" @click="cookiesManagement">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/settings-fill-blue.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('settings_cookies_title_1') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-arrow" src="/img/icons/arrow-grey.svg">
                    </div>
                </div>

                <div class="settings__bloc-divider-container">
                    <div class="settings__bloc-divider"></div>
                </div>

                <div class="settings__bloc settings__bloc-bottom" @click="goCookiesPolicy">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/document-simple-blue.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('settings_cookies_title_2') }}</p>
                    <div class="settings__bloc-item">
                        <img class="settings__bloc-item__arrow" src="/img/icons/arrow-square-up-right-fill.svg">
                    </div>
                </div>

            </div>

            <!--MY-DATA-->

            <div v-if="isPageMyData">

                <div class="settings__bloc settings__bloc-top settings__bloc-bottom"
                     :class="{'not-allowed': gdprLoader }"
                     @click="getGDPR">
                    <div class="settings__bloc-item settings__bloc-item-left">
                        <img src="/img/icons/lock-closed.svg" class="img__lang">
                    </div>
                    <p class="settings__bloc-text">{{ $t('my_data_download') }}</p>
                    <div class="settings__bloc-item">
                        <img v-show="!gdprLoader" class="settings__bloc-arrow" src="/img/icons/arrow-grey.svg">
                        <lottie-loader v-show="gdprLoader" :size="24"></lottie-loader>
                    </div>
                </div>

            </div>


        </div>

        <empty-page v-if="error"></empty-page>

        <modal-delete-account ref="MDA"
                              @close="closeModalDelete">
        </modal-delete-account>

        <toast ref="toast"></toast>

        <page-loader ref="loader"></page-loader>

        <bottom-sheet-disconnect ref="btmshtdisconnect"></bottom-sheet-disconnect>
        <bottom-sheet-not-granted ref="btmshtnotgranted"></bottom-sheet-not-granted>
        <modal-cookies-policy ref="mcp"></modal-cookies-policy>

    </div>


</template>

<script>

import Vuex from 'vuex'

import Package from '../../package'

import Api from '../api'

import ENUM from '../assets/ENUM'

import SessionStorage from '../helpers/sessionStorage'

import Auth from '../modules/auth'
import I18n from '../modules/i18n'
import Mailto from '../modules/mailTo'
import Notifs from '../modules/notifications'
import Share from '../modules/share'
import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import BottomSheetDisconnect from '../components/bottomSheet/BottomSheetDisconnect'
import BottomSheetNotGranted from '../components/bottomSheet/BottomSheetNotGranted'
import CheckboxCircle from '../components/inputs/CheckboxCircle'
import EmptyPage from '../components/EmptyPage'
import HeaderBand from '../components/headers/HeaderBand'
import LottieLoader from '../components/lottie/LottieLoader'
import Markdown from '../components/Markdown'
import ModalCookiesPolicy from '../components/modal/ModalCookiesPolicy'
import ModalDeleteAccount from '../components/modal/ModalDeleteAccount'
import PageLoader from '../components/PageLoader'
import Toast from '../components/Toast'
import CheckboxCircleV2 from '../components/inputs/CheckboxCircleV2.vue'

export default {

    name: 'settings',

    components: {
        CheckboxCircleV2,
        BottomSheetDisconnect,
        BottomSheetNotGranted,
        CheckboxCircle,
        EmptyPage,
        HeaderBand,
        LottieLoader,
        Markdown,
        ModalCookiesPolicy,
        ModalDeleteAccount,
        PageLoader,
        Toast
    },

    watch: {

        page: function (value) {

            switch (value) {
                case this.PAGES.SETTINGS:
                    UserFlow.setPage(this, 'settings')
                    Tag.pageViewGA(this, 'settings')
                    break
                case this.PAGES.DETAILS:
                    UserFlow.setPage(this, 'settings_mailbox')
                    Tag.pageViewGA(this, 'settings_mailbox')
                    break
                case this.PAGES.PANEL:
                    UserFlow.setPage(this, 'settings_panel')
                    Tag.pageViewGA(this, 'settings_panel')
                    break
                case this.PAGES.NOTIFICATIONS:
                    UserFlow.setPage(this, 'settings_notifications')
                    Tag.pageViewGA(this, 'settings_notifications')
                    break
                case this.PAGES.COOKIESPOLICY:
                    UserFlow.setPage(this, 'settings_cookies_policy')
                    Tag.pageViewGA(this, 'settings_cookies_policy')
                    break
                case this.PAGES.MYDATA:
                    UserFlow.setPage(this, 'settings_my_data')
                    Tag.pageViewGA(this, 'settings_my_data')
                    break
            }
        },

        notificationsStateAll: function (newValue, oldValue) {
            if (newValue !== oldValue && this.isPageNotifications) {
                const successText = newValue
                    ? this.$t('settings_notifications_notifications_sent')
                    : this.$t('settings_notifications_notifications_disabled')
                this.$refs.toast.open(successText)
            }
        }

    },

    computed: {

        ...Vuex.mapGetters([
            'user',
            'mailboxes',
            'fetchStatus',
            'emailToDeleteRedirect'
        ]),

        fetching() {
            return this.fetchStatus === ENUM.FETCH_STATUS.PENDING
        },

        computedTitle() {

            switch (this.page) {
                case this.PAGES.NOTIFICATIONS:
                    return this.$t('settings_notifications')
                case this.PAGES.DETAILS:
                    return this.activeEmail
                case this.PAGES.PANEL:
                    return this.$t('settings_mailbox_panel')
                case this.PAGES.COOKIESPOLICY:
                    return this.$t('settings_cookies')
                default:
                    return this.$t('settings_title')
            }
        },

        computedAccount() {

            return (this.mailboxes || []).filter(account => account.email === this.activeEmail)[0] || {}
        },

        isGerman() {
            return I18n.is.german(this)
        },

        showBackBtn() {
            return !this.pageSettings || this.pageSettings && this.fetching
        },

        isPageSettings() {
            return this.page === this.PAGES.SETTINGS
        },

        isPageDetails() {
            return this.page === this.PAGES.DETAILS
        },

        isPagePanel() {
            return this.page === this.PAGES.PANEL
        },

        isPageNotifications() {
            return this.page === this.PAGES.NOTIFICATIONS
        },

        isPageCookiesNotifications() {
            return this.page === this.PAGES.COOKIESPOLICY
        },

        isPageMyData() {
            return this.page === this.PAGES.MYDATA
        },

        notificationsStateAll() {
            return this.notificationsStateNews || this.notificationsStateImportant
        },

        notificationsStateNews() {
            return (this.settings.notifications.push.news && this.isRegistered) || false
        },

        notificationsStateImportant() {
            return (this.settings.notifications.push.important && this.isRegistered) || false
        },

        isShutdown() {
            return this.computedAccount.providerShutdown && (this.isPageDetails || this.isPagePanel)
        },

        isInvalidGrant() {
            return this.computedAccount.invalidGrant && (this.isPageDetails || this.isPagePanel) && !this.isShutdown
        },

        shutdownMessage() {
            return this.isPageDetails
                ? this.$tc('settings_provider_not_available_cleaning', 0, {provider: this.computedAccount.provider})
                : this.$tc('settings_provider_not_available_panel', 0, {provider: this.computedAccount.provider})
        },

        invalidGrantMessage() {
            return this.isPageDetails
                ? this.$t('reconnect_to_clean')
                : this.$t('reconnect_out_of_panel')
        }
    },

    data() {
        return {
            isShutdow: true,
            activeEmail: '',
            PAGES: {
                SETTINGS: 'settings',
                DETAILS: 'details',
                PANEL: 'panel',
                NOTIFICATIONS: 'notifications',
                COOKIESPOLICY: 'cookies_policy',
                MYDATA: 'my-data'
            },
            page: '',
            settings: {notifications: {push: {news: false, important: false}}},
            error: false,
            isNotGranted: true,
            isRegistered: false,
            gdprLoader: false,
            isExcludeFromPanel: undefined
        }
    },

    mounted() {

        this.getSettingsAsync()
            .then(settings => {
                if (settings) {
                    this.settings = settings
                }
            })
            .catch(() => {
                this.error = true
            })

        const firebaseAppInstanceId = Notifs.getUniqueKey()
        if (firebaseAppInstanceId) {

            Api.user.isRegisteredToPushNotifications(firebaseAppInstanceId)
                .then(data => {
                    this.isRegistered = data.notifications.isRegisteredToPushNotifications
                })
        }

        this.initPage()
    },

    methods: {

        ...Vuex.mapActions([
            'getUserAsync',
            'getSettingsAsync',
            'setUser',
            'removeMailboxes',
            'updateEmailToDeleteRedirect'
        ]),

        async initPage() {

            if (!this.user.accounts) {
                this.$refs.loader.start()
                await this.getUserAsync()
                this.$refs.loader.stop()
            }

            if (this.emailToDeleteRedirect) {
                const emailToDeleteRedirect = this.emailToDeleteRedirect
                this.updateEmailToDeleteRedirect('')
                const emailIsFromUserAccounts = this.user.accounts.some(account => account.email.localeCompare(emailToDeleteRedirect) === 0)
                if (!emailIsFromUserAccounts) {
                    this.goSettings()
                } else {
                    const indexEmail = this.user.accounts.findIndex(account => account.email === emailToDeleteRedirect) || 0
                    this.activeEmail = this.user.accounts[indexEmail].email
                    this.goDetails()
                }
            } else {
                switch (this.$route.params.page) {
                    case this.PAGES.NOTIFICATIONS:
                        this.goNotifications()
                        break
                    case this.PAGES.PANEL:
                        this.goPanel()
                        break
                    case this.PAGES.DETAILS:
                        this.goDetails()
                        break
                    default:
                        this.goSettings()
                }
            }
        },

        goDetails(emailParam) {
            if (emailParam) {
                this.activeEmail = emailParam
            }

            const account = this.computedAccount

            Tag.clickAmplitude(this, 'account', account.provider)
            this.page = this.PAGES.DETAILS
        },

        getVersion() {

            return `v${Package.version}`
        },

        goNotifications() {
            this.isNotGranted = Notifs.permission() !== 'granted'

            this.page = this.PAGES.NOTIFICATIONS
        },

        goPanel() {

            Tag.clickAmplitude(this, this.PAGES.PANEL)
            this.isExcludeFromPanel = !this.computedAccount.inFoxPanel
            this.page = this.PAGES.PANEL
        },


        goMyData() {

            Tag.clickAmplitude(this, 'my_data')
            this.page = this.PAGES.MYDATA
        },

        panelUpdate() {

            if (this.isExcludeFromPanel !== null) {

                Tag.clickGA(this, 'panel_status', this.computedAccount.provider, this.isExcludeFromPanel ? 1 : 0)

                this.isExcludeFromPanel = null

                Api.user.updatePanel(this.computedAccount.email, !this.computedAccount.inFoxPanel)
                    .then(user => {
                        return this.setUser(user)
                    })
                    .catch(() => {
                        this.$refs.toast.open()
                    })
                    .finally(() => {
                        this.isExcludeFromPanel = !this.computedAccount.inFoxPanel
                    })
            }
        },

        clickSwitchNotifs(name) {

            if (this.isNotGranted) {

                if (Notifs.permission() === 'default') {

                    Notifs.requestPermission()
                        .finally(() => {
                            const permission = Notifs.permission()

                            this.isNotGranted = permission !== 'granted'

                            if (permission === 'granted') {

                                name === 'all'
                                    ? this.notificationsUpdateAll(true)
                                    : this.specificNotificationsUpdate(true, name)
                            }
                        })

                } else {

                    this.$refs.btmshtnotgranted.open()
                }
            }
        },

        notificationsUpdateAll(bool) {

            const oldSettings = this.settings

            if (bool) {

                Notifs.register()
                    .then(() => {
                        this.isRegistered = true
                        this.getSettingsAsync()
                            .then(settings => {
                                this.settings = settings
                            })
                            .catch(() => {
                                this.error = true
                            })
                    })
                    .catch(() => {
                        this.isRegistered = false
                        this.settings = oldSettings
                    })

            } else {

                Notifs.unregister()
                    .then(() => {
                        this.isRegistered = false
                    })
                    .catch(() => {
                        this.$refs.toast.open()
                    })
            }
        },

        specificNotificationsUpdate(bool, name) {

            const options = {}
            options[name] = bool

            this.notificationsUpdate(bool, options)
        },

        notificationsUpdate(bool, options) {

            const oldSettings = this.settings

            Notifs.update(options)
                .then(settings => {
                    this.settings = settings
                })
                .catch(() => {

                    this.$refs.toast.open()
                    this.settings = oldSettings

                })
        },

        btnDisconnect() {

            this.$refs.btmshtdisconnect.open()
        },

        openModalDelete() {

            Tag.clickAmplitude(this, 'delete_mailbox')
            this.$refs.MDA.open(this.computedAccount.email)
        },

        addInbox() {

            Tag.clickAll(this, 'add_inbox')
            this.$router.push({path: '/add-inbox'})
        },

        closeModalDelete(emailToDelete) {
            if (emailToDelete) {
                this.deleteEmailAccount(emailToDelete)
            }
        },

        back() {

            switch (this.page) {
                case this.PAGES.SETTINGS:
                    // Only if fetch not done
                    this.$router.push({path: '/fetch'})
                    break
                case this.PAGES.NOTIFICATIONS:
                case this.PAGES.COOKIESPOLICY:
                case this.PAGES.DETAILS:
                case this.PAGES.MYDATA:
                    this.goSettings()
                    break
                case this.PAGES.PANEL:
                    this.goDetails()
                    break
            }
        },

        deleteEmailAccount(email) {

            Tag.clickGA(this, 'confirm_delete_mailbox')

            this.$refs.loader.start()

            Auth.deleteEmailAccount(email)
                .then(data => {
                    this.$refs.loader.stop()
                    if (data.result.user) {
                        this.goSettings()
                        this.setUser(data.result.user)
                        this.removeMailboxes(email)
                        if (data.result.user.accounts && data.result.user.accounts.length > 0) {
                            SessionStorage.setItem(SessionStorage.KEYS.EMAIL, data.result.user.accounts[0].email)
                        }
                        this.$refs.toast.open(this.$t('settings_delete_mailbox'))
                    } else {
                        Auth.disconnect(false)
                    }

                })
                .catch(() => {
                    this.$refs.loader.stop()
                    this.$refs.toast.open()
                })
        },

        goSettings() {
            this.page = this.PAGES.SETTINGS
        },

        rateCleanfox() {

            Share.rate(I18n.get(this))
        },

        contactUs() {

            Mailto.help()
        },

        goFaq() {

            window.open(`/${I18n.get(this)}/faq.html`)
        },

        goPrivacy() {

            this.$router.push({path: '/privacy'})
        },

        goYourPrivacy() {
            window.open('https://privacyportal-eu.onetrust.com/webform/07a2e8c2-346a-4f58-865f-0d56c9baaff5/a768b8f7-a45d-4184-bc88-5e761339f69e')
        },


        goHDPN() {

            this.$router.push({path: '/health-data-privacy'})
        },

        goVDP() {
            window.open('https://vdp.nielseniq.com/p/Welcome')
        },

        goTerms() {

            this.$router.push({path: '/terms'})
        },

        goCookies() {

            Tag.clickGA(this, 'cookies')
            this.page = this.PAGES.COOKIESPOLICY
        },

        cookiesManagement() {

            Tag.clickGA(this, 'manage_cookies')
            this.$refs.mcp.open()
        },

        goCookiesPolicy() {

            Tag.clickGA(this, this.PAGES.COOKIESPOLICY)
            window.open(`/${I18n.get(this)}/cookies-policy.html`)
        },

        goImpressum() {

            window.open(`/${I18n.get(this)}/impressum.html`)
        },

        getGDPR() {
            if (!this.gdprLoader) {

                Tag.clickAmplitude(this, 'download_gdpr')
                this.gdprLoader = true
                return Api.user
                    .getGDPR()
                    .then(url => {
                        if (url) {
                            const link = document.createElement('a')
                            link.href = url
                            link.download = 'cleanfox-data-portability.txt'
                            link.click()
                        } else {
                            throw new Error()
                        }
                    })
                    .catch(() => {
                        this.$refs.toast.open()
                    })
                    .finally(() => {
                        this.gdprLoader = false
                    })
            }
        },

        reconnectInvalidGrant() {
            SessionStorage.setItem(SessionStorage.KEYS.EMAIL, this.activeEmail)
            this.$router.push({path: `/login/${this.computedAccount.provider}`})
        }

    }

}
</script>

<style lang="scss" scoped>

.settings {
    min-height: inherit;
    background-color: $timberwolf;
    text-align: start;
    color: $midnight;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        background-color: $cultured;
    }

    &__spacer {
        height: 24px;
    }

    &__btn-red {
        color: $white;
    }

    &__back-img {
        height: 20px;
        object-fit: contain;
        margin-right: 4px;
        transform: rotate(180deg);

        &:lang(ar-sa) {
            transform: rotate(0deg);
        }
    }

    &__title-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }

    &__title {
        font-size: 20px;
        font-weight: bold;
        line-height: 1.2;
        color: $midnight;
    }

    &__bloc {
        width: 100%;
        height: 56px;
        padding: 16px;
        background-color: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        color: $midnight;

        &__shutdown {
            background-color: $neutralsPlatinum;
            color: $neutralsMoon;

            img {
                filter: grayscale(100%)
            }
        }
    }

    &__bloc-left {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        overflow: hidden;
    }

    &__bloc-secondary {
        padding: 0 16px 16px 16px;
        min-height: 54px;
        height: auto;
    }

    &__bloc-secondary-text {
        font-size: 13px;
        line-height: 1.38;
        color: $neutralsMoon;
    }

    &__bloc-top {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }

    &__bloc-bottom {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }

    &__bloc-item {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        .alert {
            background-color: $white;
        }

        &__arrow {
            &:lang(ar-sa) {
                transform: rotate(270deg);
            }
        }
    }

    &__bloc-item-left {
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;

        > img {
            width: 24px;
        }
    }

    &__bloc-divider-container {
        display: flex;
        width: 100%;
        background-color: $white;
    }

    &__bloc-divider {
        width: 100%;
        background-color: $silver;
        height: 1px;
    }

    &__bloc-text {
        display: flex;
        font-size: 16px;
        line-height: 1.31;
        text-align: start;
        flex: 1;
        margin: 0 0 0 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &:lang(ar-sa) {
            margin: 0 16px 0 0;
        }


    }

    &__bloc-text-left {
        margin: 0;
    }

    &__bloc-text-blue {
        color: $aquamarine;
    }

    &__bloc-text-white {
        color: $white;
        text-align: center;
        display: flex;
        justify-content: center;
    }

    &__bloc-text-red {
        color: $raspberry;
    }

    &__bloc-arrow {
        opacity: 0.3;
        transform: rotate(180deg);

        &:lang(ar-sa) {
            transform: rotate(0deg);
        }
    }

    &__bloc-img-add {
        height: 18px;
        object-fit: contain;
    }

    &__bloc-img-close {
        height: 24px;
        object-fit: contain;
    }

    &__subtitle {
        margin-bottom: 4px;
        font-size: 11px;
        font-weight: 600;
        line-height: 1.18;
        color: $neutralsMoon;
    }
}

.error-message {
    padding: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: $midnight;
    width: 100%;

    > img {
        width: 24px;
        object-fit: contain;
        margin-right: 8px;

    }

    > button {
        padding: 8px 16px;
        background-color: $aquamarine;
        border-radius: 32px;
        color: $white
    }
}

.desktop-container {
    width: 100%;
    padding: 3px 16px 105px;
    @media screen and (min-width: $above-tablet-length) {
        max-width: 480px;
        padding: 80px 0 50px;
        margin: 0 16px;
    }
}

.settings-title {
    min-height: 15px;
    font-size: 12px;
    text-transform: uppercase;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 24px;
    }
}

.privacy-text {
    opacity: 0.8;
    font-size: 12px;
}

.settings-grey-logo-container {
    margin-top: 24px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.app-version {
    opacity: 0.6;
    font-size: 12px;
    font-weight: 600;
    color: $grey;
    text-align: center;
}

.text {
    display: flex;
    font-size: 12px;
    line-height: 1.33;
    color: $grey;
    opacity: 0.8;
}

.text-panel {
    display: block;
    margin-top: 24px;
}


.band-disconnect {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: $raspberry;
    margin: 36px 0 16px;
    /*<!--@media screen and (min-width: $above-tablet-length) {-->*/
    /*<!--    margin: 21px 0 0;-->*/
    /*<!--}-->*/
}

.desktop-shadow {
    /*<!--@media screen and (min-width: $above-tablet-length) {-->*/
    /*<!--    box-shadow: 0 1px 5px 1px rgba(0, 0, 0, 0.15);-->*/
    /*<!--}-->*/
}

.logo-provider-container {
    height: 32px;
    width: 32px;
    border-radius: 4px;
    border: 1px solid $border-grey;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.logo-provider {
    height: 26px;
    width: 26px;
}

.email-container {
    display: flex;
    flex: 1;
}

.logo-add-account-container {
    height: 32px;
    width: 32px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    /*<!--@media screen and (min-width: $above-tablet-length) {-->*/
    /*<!--    margin-right: 22px;-->*/
    /*<!--}-->*/
}

.logo-add-account {
    height: 20px;
    width: 20px;
}

.band-clean {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.band-top {
    margin-top: 16px;
}

.band-delete {
    color: $raspberry;
    display: flex;
    align-items: center;
    justify-content: center;
}

.delete-warning {
    font-size: 12px;
    line-height: 1.33;
    color: $raspberry;
    margin: 10px 16px;
    display: flex;
}

.not-allowed {
    cursor: not-allowed;
}

</style>
